module.exports = __webpack_public_path__ + "img/capri-sonne.7048ff3d.png";